import { useState, useEffect } from "react"
import { useSearchParams } from "react-router-dom"
import toast from "react-hot-toast";
import LoaderIcon from 'react-loading-icons'
import api from "../components/api";


interface iClientes {

    cliente_id: number,
    nomeFantasia: string,
    cnpj: string,

}

interface iDados {

    corretor_id: number,
    nomeCorretor: string,
    tomador_id: number | null,
    nome: string,
    cidade: string,
    uf: string,
    contato: string,
    email: string,
    telefone: string,

}


// porta do relatório crm_rel_tomador.asp (e da versão de impressão crm_rel_tomador_print.asp)
const RelatorioTomador = () => {

    const [searchParams] = useSearchParams()

    const [ordem, setOrdem] = useState<string>(searchParams.get('ordem') == 'uf' ? 'uf' : 'nome')

    const [cliente_id, setCliente_id] = useState<number | undefined>()
    const [clientes, setClientes] = useState<[]>([])

    const [resultado, setResultado] = useState<iDados[]>([])
    const [carregando, setCarregando] = useState<boolean>(false)


    const dadosUsuarios = sessionStorage.getItem('dadosUsuarios')

    useEffect(() => {

        if (dadosUsuarios) {

            var dados = JSON.parse(dadosUsuarios)

            setClientes(dados.clientes)
            setCliente_id(dados.clientes.length == 1 ? dados.clientes[0].cliente_id : localStorage.getItem('cliente_id') ? Number(localStorage.getItem('cliente_id')) : undefined)

        }

    }, [dadosUsuarios])


    const consulta = async () => {

        if (!cliente_id) {
            return false
        }

        setCarregando(true)

        try {

            const response = await api.post('relTomadorPorCorretor', { cliente_id: cliente_id, ordem: ordem })
            setResultado(response.data)

        } catch (err) {
            console.error(err)
            toast.error('Erro ao gerar relatório')
        } finally {
            setCarregando(false)
        }

    }

    useEffect(() => {

        consulta()

    }, [cliente_id, ordem])


    // agrupa por corretor mantendo a ordem vinda da API
    const grupos: { corretor_id: number, nomeCorretor: string, tomadores: iDados[] }[] = []

    resultado.forEach((rs) => {

        let grupo = grupos.find(g => g.corretor_id == rs.corretor_id)

        if (!grupo) {
            grupo = { corretor_id: rs.corretor_id, nomeCorretor: rs.nomeCorretor, tomadores: [] }
            grupos.push(grupo)
        }

        if (rs.tomador_id) {
            grupo.tomadores.push(rs)
        }

    })

    const totalTomadores = grupos.reduce((t, g) => t + g.tomadores.length, 0)


    return (

        <div>

            <div className="page-breadcrumb d-none d-sm-flex align-items-center mb-3">
                <div className="breadcrumb-title pe-3">Relatório</div>
                <div className="ps-3">
                    <nav aria-label="breadcrumb">
                        <ol className="breadcrumb mb-0 p-0">
                            <li className="breadcrumb-item">Tomadores</li>
                            <li className="breadcrumb-item active" aria-current="page">{ordem == 'uf' ? 'Por estado' : 'Por nome'}</li>
                        </ol>
                    </nav>
                </div>
            </div>

            <div className="row g-3 d-print-none">

                <div className="col-md-2">
                    <label className="form-label">Ordenar</label>
                    <select className="form-control" value={ordem} onChange={event => setOrdem(event.target.value)} >
                        <option value="nome">Por nome</option>
                        <option value="uf">Por estado</option>
                    </select>
                </div>

                <div className="col-md-4">
                    <label className="form-label">Afiançadora</label>
                    <select className="form-control" value={cliente_id} disabled={clientes.length > 1 ? false : true} onChange={event => setCliente_id(event.target.value ? Number(event.target.value) : undefined)} >
                        {clientes.length > 1 && (<option value="">[Selecione]</option>)}
                        {
                            clientes.map((rs: iClientes) =>
                                <option key={rs.cliente_id} value={rs.cliente_id}>{rs.cnpj} - {rs.nomeFantasia}</option>
                            )
                        }
                    </select>
                </div>

                <div className="col-md-2 d-flex align-items-end">
                    <button type="button" className="btn btn-secondary" onClick={() => window.print()}>Imprimir</button>
                </div>

            </div>

            <center>
                <LoaderIcon.Puff stroke="#000" style={{ display: carregando ? 'block' : 'none' }} />
            </center>

            {
                !carregando && grupos.length > 0 && (

                    <div className="card mt-3">
                        <div className="card-body table-responsive">

                            <table className="table table-striped table-sm align-middle mb-0">
                                <thead>
                                    <tr>
                                        <th style={{ width: '40%' }}>Nome</th>
                                        <th>Cidade</th>
                                        <th>UF</th>
                                        <th>Contato</th>
                                        <th>Email</th>
                                        <th>Tel</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {
                                        grupos.map((g) =>
                                            [
                                                <tr key={`c${g.corretor_id}`} className="table-secondary">
                                                    <td colSpan={6}><b>CORRETOR: {g.nomeCorretor}</b></td>
                                                </tr>,
                                                ...g.tomadores.map((rs) =>
                                                    <tr key={`c${g.corretor_id}t${rs.tomador_id}`}>
                                                        <td>{rs.nome}</td>
                                                        <td>{rs.cidade}</td>
                                                        <td>{rs.uf}</td>
                                                        <td>{rs.contato}</td>
                                                        <td>{rs.email}</td>
                                                        <td>{rs.telefone}</td>
                                                    </tr>
                                                )
                                            ]
                                        )
                                    }
                                </tbody>
                            </table>

                            <p className="mt-3 mb-0">Total de registros: <b>{totalTomadores}</b></p>

                        </div>
                    </div>

                )
            }

        </div>

    )

}

export default RelatorioTomador
